import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ParametrageRoutingModule } from './parametrage-routing.module';
import { ParametrageChildOutletComponent } from './parametrage-child-outlet.component';
import { SharedModule } from '../shared/shared.module';
import { CurrencyComponent } from './currency/currency.component';
import { CountryComponent } from './country/country.component';
import { NetworkComponent } from './network/network.component';
import { CityComponent } from './city/city.component';
import { BankComponent } from './bank/bank.component';
import { DirectionComponent } from './direction/direction.component';
import { DepartementComponent } from './departement/departement.component';
import { PermissionComponent } from './permission/permission.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { UserComponent } from './user/user.component';
import { WorkflowComponent } from './workflow/workflow.component';
import { RequestStatusComponent } from './request-status/request-status.component';
import { FormulaireComponent } from './formulaire/formulaire.component';
import { ServiceExecutionComponent } from './service-execution/service-execution.component';
import { TaskComponent } from './task/task.component';
import { TypeCreditComponent } from './type-credit/type-credit.component';
import { ProduitComponent } from './produit/produit.component';
import { LegalFormComponent } from './legal-form/legal-form.component';
import { ActivityAreaComponent } from './activity-area/activity-area.component';
import { AssuranceComponent } from './assurance/assurance.component';
import { AnneeComponent } from './annee/annee.component';
import { FerierComponent } from './ferier/ferier.component';
import { TypeCongesComponent } from './type-conges/type-conges.component';
import { StatutDossierComponent } from './statut-dossier/statut-dossier.component';
import { MarcheComponent } from './marche/marche.component';
import { FournisseurAgreeComponent } from './fournisseur-agree/fournisseur-agree.component';
import { AddFournisseurAgreeComponent } from './fournisseur-agree/add-fournisseur-agree/add-fournisseur-agree.component';
import { EditFournisseurAgreeComponent } from './fournisseur-agree/edit-fournisseur-agree/edit-fournisseur-agree.component';
import { AddMarcheComponent } from './marche/add-marche/add-marche.component';
import { EditMarcheComponent } from './marche/edit-marche/edit-marche.component';
import { EditExpositionNetteFourAgreeComponent } from './fournisseur-agree/edit-exposition-nette-four-agree/edit-exposition-nette-four-agree.component';
import { AddNetworkComponent } from './network/add-network/add-network.component';
import { EditNetworkComponent } from './network/edit-network/edit-network.component';
import { AddCityComponent } from './city/add-city/add-city.component';
import { EditCityComponent } from './city/edit-city/edit-city.component';
import { AddBankComponent } from './bank/add-bank/add-bank.component';
import { EditBankComponent } from './bank/edit-bank/edit-bank.component';
import { AddDirectionComponent } from './direction/add-direction/add-direction.component';
import { EditDirectionComponent } from './direction/edit-direction/edit-direction.component';
import { AddDepartementComponent } from './departement/add-departement/add-departement.component';
import { EditDepartementComponent } from './departement/edit-departement/edit-departement.component';
import { EditCountryComponent } from './country/edit-country/edit-country.component';
import { AddTypeCreditComponent } from './type-credit/add-type-credit/add-type-credit.component';
import { EditTypeCreditComponent } from './type-credit/edit-type-credit/edit-type-credit.component';
import { EditProduitComponent } from './produit/edit-produit/edit-produit.component';
import { AddProduitComponent } from './produit/add-produit/add-produit.component';
import { GarantieProduitComponent } from './garantie-produit/garantie-produit.component';
import { AddGarantieProduitComponent } from './garantie-produit/add-garantie-produit/add-garantie-produit.component';
import { EditGarantieProduitComponent } from './garantie-produit/edit-garantie-produit/edit-garantie-produit.component';
import { LimiteProduitComponent } from './limite-produit/limite-produit.component';
import { AddLimiteProduitComponent } from './limite-produit/add-limite-produit/add-limite-produit.component';
import { EditLimiteProduitComponent } from './limite-produit/edit-limite-produit/edit-limite-produit.component';
import { EditLegalFormComponent } from './legal-form/edit-legal-form/edit-legal-form.component';
import { AddLegalFormComponent } from './legal-form/add-legal-form/add-legal-form.component';
import { AddActivityAreaComponent } from './activity-area/add-activity-area/add-activity-area.component';
import { EditActivityAreaComponent } from './activity-area/edit-activity-area/edit-activity-area.component';
import { AddAssuranceComponent } from './assurance/add-assurance/add-assurance.component';
import { EditAssuranceComponent } from './assurance/edit-assurance/edit-assurance.component';
import { AddFerierComponent } from './ferier/add-ferier/add-ferier.component';
import { EditFerierComponent } from './ferier/edit-ferier/edit-ferier.component';
import { AddFormulaireComponent } from './formulaire/add-formulaire/add-formulaire.component';
import { EditFormulaireComponent } from './formulaire/edit-formulaire/edit-formulaire.component';
import { AddTaskComponent } from './task/add-task/add-task.component';
import { EditTaskComponent } from './task/edit-task/edit-task.component';
import { AffectationComponent } from './affectation/affectation.component';
import { AddAffectationComponent } from './affectation/add-affectation/add-affectation.component';
import { EditAffectationComponent } from './affectation/edit-affectation/edit-affectation.component';
import { TaskDocumentComponent } from './task-document/task-document.component';
import { AddTaskDocumentComponent } from './task-document/add-task-document/add-task-document.component';
import { EditTaskDocumentComponent } from './task-document/edit-task-document/edit-task-document.component';
import { AddPermissionComponent } from './permission/add-permission/add-permission.component';
import { EditPermissionComponent } from './permission/edit-permission/edit-permission.component';
import { PermissionByProfileComponent } from './user-profile/permission-by-profile/permission-by-profile.component';
import { EditUserProfileComponent } from './user-profile/edit-user-profile/edit-user-profile.component';
import { RuleEngineComponent } from './rule-engine/rule-engine.component';
import { AddRuleEngineComponent } from './rule-engine/add-rule-engine/add-rule-engine.component';
import { EditRuleEngineComponent } from './rule-engine/edit-rule-engine/edit-rule-engine.component';
import { CheckListDocumentComponent } from './check-list-document/check-list-document.component';
import { AddCheckListComponent } from './check-list-document/add-check-list/add-check-list.component';
import { EditCheckListComponent } from './check-list-document/edit-check-list/edit-check-list.component';
import { SmtpConfigComponent } from './smtp-config/smtp-config.component';
import { AddSmtpConfigComponent } from './smtp-config/add-smtp-config/add-smtp-config.component';
import { EditSmtpConfigComponent } from './smtp-config/edit-smtp-config/edit-smtp-config.component';
import { EmployeurComponent } from './employeur/employeur.component';
import { AddEmployeurComponent } from './employeur/add-employeur/add-employeur.component';
import { EditEmployeurComponent } from './employeur/edit-employeur/edit-employeur.component';
import { ProfileByUserComponent } from './user/profile-by-user/profile-by-user.component';
import { AddUserComponent } from './user/add-user/add-user.component';
import { EditUserComponent } from './user/edit-user/edit-user.component';
import { ImportUserComponent } from './user/import-user/import-user.component';
import { DesactiverUserComponent } from './user/desactiver-user/desactiver-user.component';
import { ChangerAgenceUserComponent } from './user/changer-agence-user/changer-agence-user.component';
import { AddCongesComponent } from './user/add-conges/add-conges.component';
import { EditCongesComponent } from './user/edit-conges/edit-conges.component';
import { NatureGarantieComponent } from './garantie/nature-garantie/nature-garantie.component';
import { AddNatureGarantieComponent } from './garantie/nature-garantie/add-nature-garantie/add-nature-garantie.component';
import { SetTypeDocumentNatureGarantieComponent } from './garantie/nature-garantie/set-type-document-nature-garantie/set-type-document-nature-garantie.component';
import { ChampFormGarantieComponent } from './garantie/champ-form-garantie/champ-form-garantie.component';
import { AddTypeDocumentGarantieComponent } from './garantie/types-documents-garanties/add-type-document-garantie/add-type-document-garantie.component';
import { TypesDocumentsGarantiesComponent } from './garantie/types-documents-garanties/types-documents-garanties.component';
import { AddChampSourceGarantieComponent } from './garantie/champ-form-garantie/add-champ-source-garantie/add-champ-source-garantie.component';
import { SetTypeChampGarantieComponent } from './garantie/nature-garantie/set-type-champ-garantie/set-type-champ-garantie.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { MembreComiteComponent } from './membre-comite/membre-comite.component';
import { AddMembreComiteComponent } from './membre-comite/add-membre-comite/add-membre-comite.component';
import { EditMembreComiteComponent } from './membre-comite/edit-membre-comite/edit-membre-comite.component';
import { ObjectifProfilTypeCreditComponent } from './objectif-profil-type-credit/objectif-profil-type-credit.component';
import { AddObjectifProfilTypeCreditComponent } from './objectif-profil-type-credit/add-objectif-profil-type-credit/add-objectif-profil-type-credit.component';
import { EditObjectifProfilTypeCreditComponent } from './objectif-profil-type-credit/edit-objectif-profil-type-credit/edit-objectif-profil-type-credit.component';
import { ProduitCrmComponent } from './produit-crm/produit-crm.component';
import { ChampProduitCrmComponent } from './produit-crm/champ-produit-crm/champ-produit-crm.component';
import { AddChampProduitCrmComponent } from './produit-crm/champ-produit-crm/add-champ-produit-crm/add-champ-produit-crm.component';
import { TypeDocumentProduitCrmComponent } from './produit-crm/type-document-produit-crm/type-document-produit-crm.component';
import { NatureProduitCrmComponent } from './produit-crm/nature-produit-crm/nature-produit-crm.component';
import { AddTypeDocumentProduitCrmComponent } from './produit-crm/type-document-produit-crm/add-type-document-produit-crm/add-type-document-produit-crm.component';
import { AddNatureProduitCrmComponent } from './produit-crm/nature-produit-crm/add-nature-produit-crm/add-nature-produit-crm.component';
import { SetTypeChampProduitCrmComponent } from './produit-crm/nature-produit-crm/set-type-champ-produit-crm/set-type-champ-produit-crm.component';
import { SetTypeDocumentProduitCrmComponent } from './produit-crm/nature-produit-crm/set-type-document-produit-crm/set-type-document-produit-crm.component';
import { ClassificationEmployeurComponent } from './classification-employeur/classification-employeur.component';
import { AddClassificationEmployeurComponent } from './classification-employeur/add-classification-employeur/add-classification-employeur.component';
import { EditClassificationEmployeurComponent } from './classification-employeur/edit-classification-employeur/edit-classification-employeur.component';
import { MonacoEditorModule } from 'ngx-monaco-editor';
import { ParametreGeneralComponent } from './parametre-general/parametre-general.component';
import { AddParametreGeneralComponent } from './parametre-general/add-parametre-general/add-parametre-general.component';
import { EditParametreGeneralComponent } from './parametre-general/edit-parametre-general/edit-parametre-general.component';
import { LigneFinancementComponent } from './ligneFinancement/ligne-financement/ligne-financement.component';
import { LigneFinancementProduitComponent } from './ligneFinancement/ligne-financement-produit/ligne-financement-produit.component';
import { LigneFinancementSecteurComponent } from './ligneFinancement/ligne-financement-secteur/ligne-financement-secteur.component';
import { LigneFinancementMarcheComponent } from './ligneFinancement/ligne-financement-marche/ligne-financement-marche.component';
import { AddLigneFinancementComponent } from './ligneFinancement/ligne-financement/add-ligne-financement/add-ligne-financement.component';
import { EditLigneFinancementComponent } from './ligneFinancement/ligne-financement/edit-ligne-financement/edit-ligne-financement.component';
import { EditLigneFinancementMarcheComponent } from './ligneFinancement/ligne-financement-marche/edit-ligne-financement-marche/edit-ligne-financement-marche.component';
import { AddLigneFinancementMarcheComponent } from './ligneFinancement/ligne-financement-marche/add-ligne-financement-marche/add-ligne-financement-marche.component';
import { AddLigneFinancementProduitComponent } from './ligneFinancement/ligne-financement-produit/add-ligne-financement-produit/add-ligne-financement-produit.component';
import { EditLigneFinancementProduitComponent } from "./ligneFinancement/ligne-financement-produit/editigne-financement-produit/editigne-financement-produit.component";
import { AddLigneFinancementSecteurComponent } from './ligneFinancement/ligne-financement-secteur/add-ligne-financement-secteur/add-ligne-financement-secteur.component';
import { EditLigneFinancementSecteurComponent } from './ligneFinancement/ligne-financement-secteur/edit-ligne-financement-secteur/edit-ligne-financement-secteur.component';
import { ScoringParametreComponent } from './scoring-parametre/scoring-parametre.component';
import { AddScoringParametreComponent } from './scoring-parametre/add-scoring-parametre/add-scoring-parametre.component';
import { EditScoringParametreComponent } from './scoring-parametre/edit-scoring-parametre/edit-scoring-parametre.component';



@NgModule({
  imports: [
    CommonModule,
    ParametrageRoutingModule,
    SharedModule,
    DragDropModule,
    MonacoEditorModule
  ],

  declarations: [
    ParametrageChildOutletComponent,
    CurrencyComponent,
    CountryComponent,
    NetworkComponent,
    CityComponent,
    BankComponent,
    DirectionComponent,
    DepartementComponent,
    PermissionComponent,
    AddPermissionComponent,
    EditPermissionComponent,
    PermissionByProfileComponent,
    UserProfileComponent,
    EditUserProfileComponent,
    UserComponent,
    WorkflowComponent,
    RequestStatusComponent,
    FormulaireComponent,
    AddFormulaireComponent,
    EditFormulaireComponent,
    ServiceExecutionComponent,
    TaskComponent,
    AddTaskComponent,
    EditTaskComponent,
    AffectationComponent,
    AddAffectationComponent,
    EditAffectationComponent,
    TaskDocumentComponent,
    AddTaskDocumentComponent,
    EditTaskDocumentComponent,
    TypeCreditComponent,
    ProduitComponent,
    LegalFormComponent,
    AddLegalFormComponent,
    EditLegalFormComponent,
    ActivityAreaComponent,
    AddActivityAreaComponent,
    EditActivityAreaComponent,
    AssuranceComponent,
    AddAssuranceComponent,
    EditAssuranceComponent,
    AnneeComponent,
    FerierComponent,
    AddFerierComponent,
    EditFerierComponent,
    TypeCongesComponent,
    StatutDossierComponent,
    MarcheComponent,
    FournisseurAgreeComponent,
    AddFournisseurAgreeComponent,
    EditFournisseurAgreeComponent,
    AddMarcheComponent,
    EditMarcheComponent,
    EditExpositionNetteFourAgreeComponent,
    AddNetworkComponent,
    EditNetworkComponent,
    AddCityComponent,
    EditCityComponent,
    AddBankComponent,
    EditBankComponent,
    AddDirectionComponent,
    EditDirectionComponent,
    AddDepartementComponent,
    EditDepartementComponent,
    EditCountryComponent,
    AddTypeCreditComponent,
    EditTypeCreditComponent,
    AddProduitComponent,
    EditProduitComponent,
    GarantieProduitComponent,
    AddGarantieProduitComponent,
    EditGarantieProduitComponent,
    LimiteProduitComponent,
    AddLimiteProduitComponent,
    EditLimiteProduitComponent,
    RuleEngineComponent,
    AddRuleEngineComponent,
    EditRuleEngineComponent,
    CheckListDocumentComponent,
    AddCheckListComponent,
    EditCheckListComponent,
    SmtpConfigComponent,
    AddSmtpConfigComponent,
    EditSmtpConfigComponent,
    EmployeurComponent,
    AddEmployeurComponent,
    EditEmployeurComponent,
    ProfileByUserComponent,
    AddUserComponent,
    EditUserComponent,
    ImportUserComponent,
    DesactiverUserComponent,
    ChangerAgenceUserComponent,
    AddCongesComponent,
    EditCongesComponent,
    NatureGarantieComponent,
    AddNatureGarantieComponent,
    TypesDocumentsGarantiesComponent,
    AddTypeDocumentGarantieComponent,
    SetTypeDocumentNatureGarantieComponent,
    ChampFormGarantieComponent,
    AddChampSourceGarantieComponent,
    SetTypeChampGarantieComponent,
    MembreComiteComponent,
    AddMembreComiteComponent,
    EditMembreComiteComponent,
    ObjectifProfilTypeCreditComponent,
    AddObjectifProfilTypeCreditComponent,
    EditObjectifProfilTypeCreditComponent,
    ProduitCrmComponent,
    ChampProduitCrmComponent,
    AddChampProduitCrmComponent,
    TypeDocumentProduitCrmComponent,
    NatureProduitCrmComponent,
    AddTypeDocumentProduitCrmComponent,
    AddNatureProduitCrmComponent,
    SetTypeChampProduitCrmComponent,
    SetTypeDocumentProduitCrmComponent,
    ClassificationEmployeurComponent,
    AddClassificationEmployeurComponent,
    EditClassificationEmployeurComponent,
    ParametreGeneralComponent,
    AddParametreGeneralComponent,
    EditParametreGeneralComponent,
    LigneFinancementComponent,
    LigneFinancementProduitComponent,
    LigneFinancementSecteurComponent,
    LigneFinancementMarcheComponent,
    AddLigneFinancementComponent,
    EditLigneFinancementComponent,
    EditLigneFinancementMarcheComponent,
    AddLigneFinancementMarcheComponent,
    AddLigneFinancementProduitComponent,
    EditLigneFinancementProduitComponent,
    AddLigneFinancementSecteurComponent,
    EditLigneFinancementSecteurComponent,
    ScoringParametreComponent,
    AddScoringParametreComponent,
    EditScoringParametreComponent
  ],

  entryComponents: [
    AddFournisseurAgreeComponent,
    EditFournisseurAgreeComponent,
    AddMarcheComponent,
    EditMarcheComponent,
    EditExpositionNetteFourAgreeComponent,
    AddNetworkComponent,
    EditNetworkComponent,
    AddDirectionComponent,
    EditDirectionComponent,
    AddDepartementComponent,
    EditDepartementComponent,
    AddGarantieProduitComponent,
    EditGarantieProduitComponent,
    AddLimiteProduitComponent,
    EditLimiteProduitComponent,
    AddAssuranceComponent,
    EditAssuranceComponent,
    AddFerierComponent,
    EditFerierComponent,
    AddFormulaireComponent,
    EditFormulaireComponent,
    AddAffectationComponent,
    EditAffectationComponent,
    AddTaskDocumentComponent,
    EditTaskDocumentComponent,
    AddRuleEngineComponent,
    EditRuleEngineComponent,
    AddCheckListComponent,
    EditCheckListComponent,
    AddSmtpConfigComponent,
    EditSmtpConfigComponent,
    AddEmployeurComponent,
    EditEmployeurComponent,
    ImportUserComponent,
    DesactiverUserComponent,
    ChangerAgenceUserComponent,
    AddCongesComponent,
    EditCongesComponent,
    AddNatureGarantieComponent,
    AddTypeDocumentGarantieComponent,
    SetTypeDocumentNatureGarantieComponent,
    AddChampSourceGarantieComponent,
    SetTypeChampGarantieComponent,
    AddMembreComiteComponent,
    EditMembreComiteComponent,
    AddObjectifProfilTypeCreditComponent,
    EditObjectifProfilTypeCreditComponent,
    AddChampProduitCrmComponent,
    AddTypeDocumentProduitCrmComponent,
    AddNatureProduitCrmComponent,
    SetTypeChampProduitCrmComponent,
    SetTypeDocumentProduitCrmComponent,
    AddClassificationEmployeurComponent,
    EditClassificationEmployeurComponent,
    AddParametreGeneralComponent,
    EditParametreGeneralComponent,
    AddLigneFinancementComponent,
    EditLigneFinancementComponent,
    EditLigneFinancementMarcheComponent,
    AddLigneFinancementMarcheComponent,
    AddLigneFinancementProduitComponent,
    EditLigneFinancementProduitComponent,
    AddLigneFinancementSecteurComponent,
    EditLigneFinancementSecteurComponent
  ],

  providers: []
})
export class ParametrageModule {}